import { z } from "zod";

import { ContactMessageItemInputSchema, ContactUpdateInputSchema } from "@/lib/zod/__generated__/validation-schema";

import { s3ObjectZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

export const contactUpdateInputZodSchema = ContactUpdateInputSchema.extend({
	message: ContactMessageItemInputSchema.extend({
		message: z
			.string()
			.min(1, "問い合わせ内容を入力してください")
			.max(3000, "問い合わせ内容は3000文字以内で入力してください"),
		relatedURLs: z.array(z.string().url().or(z.literal(""))),
		images: z
			.array(s3ObjectZodSchema)
			.nullish()
			.refine(
				(images) => {
					return !images || images.length <= 4;
				},
				{
					message: "画像は4枚以内で入力してください",
				},
			),
	}),
});

export type ContactUpdateInputZodSchemaType = z.infer<typeof contactUpdateInputZodSchema>;
